import React, {FC} from 'react'
import {Modal} from 'react-bootstrap'

interface Props {
  show: boolean
  onClose: () => void
  onProceed: () => void
}

export const EditWithoutUnlinkingWarningModal: FC<Props> = ({show, onClose, onProceed}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop='static'
      style={{zIndex: 1065}}
      dialogClassName='modal-dialog-centered'
      contentClassName='border-0 shadow-lg'
    >
      <div
        className='position-relative bg-white'
        style={{borderRadius: '16px', padding: '32px 28px 28px'}}
      >
        <button
          type='button'
          className='btn-close position-absolute top-0 end-0 m-4'
          aria-label='Close'
          onClick={onClose}
          style={{fontSize: '11px'}}
        ></button>

        <div className='text-center'>
          <div
            className='d-inline-flex justify-content-center align-items-center mb-4'
            style={{
              width: '54px',
              height: '54px',
              borderRadius: '50%',
              backgroundColor: '#f5f7e8',
              color: '#8b9a38',
              border: '2px solid #8b9a38',
            }}
          >
            <span style={{fontSize: '26px', fontWeight: 'bold', lineHeight: '1'}}>!</span>
          </div>
          <p
            className='fw-bold text-dark fs-5 mb-5 px-3'
            style={{lineHeight: '1.4', fontFamily: 'inherit'}}
          >
            Edit without un-linking will make changes in existing invoice. Please ensure reconciliation at your end.
          </p>
          <div className='d-flex justify-content-center gap-3'>
            <button
              type='button'
              className='btn btn-light bg-white border border-gray-300 px-6 py-2 fw-semibold text-gray-700'
              style={{minWidth: '100px', borderRadius: '8px'}}
              onClick={onClose}
            >
              Close
            </button>
            <button
              type='button'
              className='btn px-6 py-2 fw-semibold text-white'
              style={{
                minWidth: '110px',
                borderRadius: '8px',
                backgroundColor: '#959f42',
                borderColor: '#959f42',
              }}
              onClick={onProceed}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default EditWithoutUnlinkingWarningModal
